import { commonFilter } from './filter';

export default {
  pageName: 'Steam Ratings',
  pageId: '20114',
  pagePath: '/opinion/SteamPerformance/SteamRatings',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
